import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n'

// Avoid Google Translate
document.documentElement.setAttribute('translate', 'no');
const meta = document.createElement('meta');
meta.name = "google";
meta.content = "notranslate";
document.head.appendChild(meta);

const root = ReactDOM.createRoot(
  document.getElementById('cigo-auth-root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
